import { viewerPermissions } from '../helpers/permissions';

import waypointScenario from './waypoint';

export default function (server, options = {}) {
  waypointScenario(server, {
    allowedPermissions: viewerPermissions,
  });
}
